import { IcCapture } from '@assets/icons/32x32';
import { Icon } from '@chakra-ui/react';
import { ButtonBar } from '@components/ui/buttonBar';
import { useAppSelector } from '@hooks/redux.hooks';
import { PerimeterCameraSelectors } from '@redux/sensors/sensors.selectors';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';

import { PerimeterCamera } from '@/types/sensor/sensors/perimeterCamera.types';

type OwnProps = {
  selectedPerimeterCameraUniqueKey: string | null;
  downloadScreenshot: (cameraName?: string) => void;
};

export default function CameraPerimButtons({
  downloadScreenshot,
  selectedPerimeterCameraUniqueKey,
}: Readonly<OwnProps>) {
  const { formatMessage } = useIntl();

  const perimeterCameraConfig: PerimeterCamera | undefined = useAppSelector(
    (state) => PerimeterCameraSelectors.selectPerimeterCameraByUniqueKey(state, selectedPerimeterCameraUniqueKey ?? ''),
    isEqual,
  );
  const perimeterCameraName = perimeterCameraConfig?.name;

  return (
    <ButtonBar.Root
      aria-label={formatMessage({ id: 'cameras.cameraMenu.capture' })}
      size="md"
      onClick={() => downloadScreenshot(perimeterCameraName)}
    >
      <Icon as={IcCapture} />
    </ButtonBar.Root>
  );
}
